<template>
  <span class="pm-row">
    <v-tooltip
      v-for="pm in visiblePlanningMarkets"
      :key="pm.id"
      bottom>
      <template v-slot:activator="{ on, attrs }">
        <span class="pm-item" v-bind="attrs" v-on="on">
          <base-label-with-flag
            :item-label="pm.abbreviation"
            :item-country="pm.logisticCountry.code"
            :size="size"/>
        </span>
      </template>
      <span>{{ pm.description }}</span>
    </v-tooltip>
    <v-tooltip v-if="hiddenPlanningMarkets.length > 0" bottom>
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on" class="text--secondary caption ml-1" style="cursor:default;">
          (+{{ hiddenPlanningMarkets.length }} more)
        </span>
      </template>
      <span>
        <div v-for="pm in hiddenPlanningMarkets" :key="pm.id">
          <base-label-with-flag :item-country="pm.logisticCountry.code" :item-label="pm.description"/>
        </div>
      </span>
    </v-tooltip>
  </span>
</template>

<script>
import BaseLabelWithFlag from '@/base/label/BaseLabelWithFlag'

export default {
  name: 'BasePlanningMarketWithToolTip',
  components: {
    BaseLabelWithFlag
  },
  props: {
    planningMarkets: {
      type: Array,
      required: true
    },
    threshold: {
      type: Number,
      required: false,
      default: 1
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
      validator: value => ['small', 'medium', 'large'].includes(value)
    }
  },
  computed: {
    visiblePlanningMarkets () {
      return this.planningMarkets.slice(0, this.threshold)
    },
    hiddenPlanningMarkets () {
      return this.planningMarkets.slice(this.threshold)
    }
  }
}
</script>

<style scoped>
.pm-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}

.pm-item {
  display: inline-flex;
  align-items: center;
}
</style>
